import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
var Card = /*#__PURE__*/function (_Component) {
  function Card(props) {
    var _this;
    _classCallCheck(this, Card);
    _this = _callSuper(this, Card, [props]);
    _defineProperty(_this, "output", function () {
      var target = _this.props.target;
      var isExternal = !!(target && target.indexOf('http') > -1);
      var isInternal = !!(target && !isExternal);
      if (isExternal) {
        return /*#__PURE__*/React.createElement("a", {
          href: target,
          target: "_blank",
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      } else if (isInternal) {
        return /*#__PURE__*/React.createElement(Link, {
          to: target,
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      }
      if (_this.props.onClick != null && target == null) {
        return /*#__PURE__*/React.createElement("a", {
          onClick: _this.props.onClick,
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      }

      // console.warn('Deprecation warning: Missing target attribute for card.
      // Please use an internal or external link in prop target.');
      // TODO: Remove the type checks below and make sure all cards have a
      // target attribute. Target will work with both external and internal
      // links and figures out how to handle them (based on http or not in url).

      if (_this.props.type === 'task') {
        return /*#__PURE__*/React.createElement(Link, {
          to: "/assignment/".concat(_this.props.id),
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      } else if (_this.props.type === 'planning') {
        return /*#__PURE__*/React.createElement(Link, {
          to: "/plan/".concat(_this.props.id),
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      } else if (_this.props.type === 'news') {
        return _this.props.item.id != 0 ? /*#__PURE__*/React.createElement(Link, {
          to: "/posts/".concat(_this.props.id),
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children) : /*#__PURE__*/React.createElement("a", {
          href: _this.props.item.section.classroomUrl,
          target: "_blank",
          className: "card card-".concat(_this.state.type)
        }, _this.props.children);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "card card-".concat(_this.state.type),
        style: _objectSpread({
          borderLeftColor: _this.state.color
        }, _this.props.style)
      }, _this.props.children);
    });
    _this.state = {
      color: _this.props.hasOwnProperty('color') ? _this.props.color : '',
      type: _this.props.hasOwnProperty('type') ? _this.props.type : 'standard'
    };
    return _this;
  }
  _inherits(Card, _Component);
  return _createClass(Card, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "card-outer",
        key: this.props.id
      }, this.output());
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    activeStudent: state.guardians.activeStudent
  };
};
export default connect(mapStateToProps)(Card);

/**
* Cards container
* Displays cards in multiple columns based on screen width.
* @export CardsContainer
*/
export var CardsContainer = function CardsContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "cards-container"
  }, children);
};

/**
* Card title
*/
export var CardTitle = function CardTitle(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "card_title"
  }, children);
};

/**
* Card subtitle
*/
export var CardSubtitle = function CardSubtitle(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "card_subtitle"
  }, children);
};

/**
* Card description
*/
export var CardDescription = function CardDescription(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "card_description"
  }, children);
};

/**
* Card footer
*/
export var CardFooter = function CardFooter(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, children);
};